export default __webpack_public_path__ + "static/media/36_4_1.ba089184.png";